import gql from "graphql-tag";

export const MY_TIME_GET_REQUEST = gql`
  query getMyTimeRequest($_id: String!) {
    getMyTimeRequest(_id: $_id) {
      _id
      myTimeType
      startTime
      endTime
      hours
      state
      timeDataTypeCode
      timeDataTypeName
      createdAt
      createdBy
      approvedAt
      approvedBy
      rejectedAt
      rejectedBy
    }
  }
`;
